import { render, staticRenderFns } from "./WalletCard.vue?vue&type=template&id=6cec6d55&scoped=true"
import script from "./WalletCard.vue?vue&type=script&lang=ts"
export * from "./WalletCard.vue?vue&type=script&lang=ts"
import style0 from "./WalletCard.vue?vue&type=style&index=0&id=6cec6d55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cec6d55",
  null
  
)

export default component.exports